import React, { Suspense, lazy, useState } from 'react';

import { ErrorBoundary } from 'react-error-boundary';

import { useIdentity } from '@vp/ubik-context';

import { TriggerLink } from '../../TriggerLink';
import { MailingServicesContentData } from '../types';

const MailingServicesTemplateModalView = lazy(() =>
  import('./MailingServicesTemplateModalView').then((m) => ({
    default: m.MailingServicesTemplateModalView,
  }))
);

export interface MailingServicesProps {
  data: MailingServicesContentData;
  locale: string;
  trigger: React.ReactNode;
}

export const MailingServices: React.FC<MailingServicesProps> = (props) => {
  const { auth } = useIdentity();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleTriggerOnClick = () => setIsModalOpen(true);

  return (
    shouldRender(props) && (
      <>
        <TriggerLink onTriggerOnClick={handleTriggerOnClick} trigger={props.trigger} />
        {isModalOpen && (
          <ErrorBoundary fallback={null} onError={() => setIsModalOpen(false)}>
            <Suspense fallback={null}>
              <MailingServicesTemplateModalView
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                data={props.data.content}
                locale={props.locale}
                authHeader={auth?.getAuthorizationHeader?.()}
              />
            </Suspense>
          </ErrorBoundary>
        )}
      </>
    )
  );
};

export const shouldRender = (
  props: Partial<Pick<MailingServicesProps, 'data'>>
): props is { data: Required<MailingServicesContentData> & { isProductSupported: true } } => {
  return !!props.data?.isProductSupported && !!props.data?.content;
};
